// extracted by mini-css-extract-plugin
module.exports = {"dark":"#0f0f0f","light":"#fefefe","primary":"#663390","active":"#663390","highlight":"#663390","disabled":"#78757a"};